<template>
  <div class="w-100">
    <!-- Contenido de la tabla -->
    <table
      class="table table-bordered stripe display compact hover"
      :id="nombreTabla">
      <!-- Headers -->
      <thead>
      <tr>
        <template>
          <th style="font-size: 13px !important; width: 70px">ID</th>
          <th style="font-size: 13px !important; width: 49px">Naviera</th>
          <th style="font-size: 13px !important; width: 127px">Nave</th>
          <th style="font-size: 13px !important; width: 127px">Viaje</th>
          <th style="font-size: 13px !important; width: 125px">N° Booking</th>
          <th style="font-size: 13px !important; width: 185px">Cant. Contenedores</th>
          <th style="font-size: 13px !important; width: 150px">Acciones</th>
        </template>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(item, index) in data" :key="index">
        <template>
          <td v-for="(item_data, index_data) in item.data" :key="index_data" style="font-size: 12.5px !important">
            {{ item_data === "-" || item_data === "" || item_data === null ? "Sin asignar" : item_data }}
          </td>
        </template>
        <td v-if="acciones.length > 0">
          <div v-if="item.data_complementaria.status === 1">
            <a  v-for="(action, action_index) in acciones[index]"
                :key="action_index"
                class="btn btn-sm icono"
                @click="downloadBL(index, action.title)">
              <i :class="action.icon"
                 :title="action.title"
                 style="text-align: center"
                 :style="[{'font-size': action.size ? action.size + 'px' : '11.7px'}]">
              </i>
            </a>
          </div>
          <div v-else>
            <a class="btn btn-sm icono"
                @click="showAlertBL()">
              <i class="fas fa-info-circle text-warning"
                 title="¡Aviso importante!"
                 style="text-align: center; font-size: 14px;">
              </i>
            </a>
          </div>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";

import $ from "jquery";

import { downloadBillLadingPDF } from "@/constants/general";

export default {
  props: {
    headers: Array, // Titulos para cabecera de la tabla
    data: Array, // Contenido o información que mostrara la tabla
    acciones: Array, // Array de configuraciones para botones de la columna "Acciones"
    paginacion: Boolean, // Si la tabla tedra activa la opción de paginación, esta opción esta deshabilitada por defecto
    max: { type: Number, default: 10 }, // Numero de filas por cada pagina
    buscar: Boolean, // Filtrar filas, esta opción esta deshabilitada por defecto
    idtabla: {
      type: String,
      default: "id_generico"
    },
  },

  data() {
    return {
      loading: true,
      lang: {
        lengthMenu: "Display _MENU_ records per page",
        zeroRecords: "No se encontraron registros coincidentes",
        info: "Mostrando página _PAGE_ de _PAGES_",
        infoEmpty: "No hay registros disponibles",
        infoFiltered: "(filtrado de _MAX_ registros totales)",
        search: "Buscar",
        paginate: {
          first: "Primero",
          last: "Último",
          next: "Siguiente",
          previous: "Anterior"
        }
      },
      nombreTabla: "id_tabla_" + this.idtabla
    };
  },
  computed: {
    ...mapState(["zIndexModal", "ZindexTablaModal"])
  },
  methods: {
    // Acciones de Vuex
    ...mapActions(["ActionSetLoading"]),

    configuracionDatatable() {
      let me = this;

      $("#" + this.nombreTabla)
        .DataTable()
        .destroy();

      $("#" + me.nombreTabla)
        .DataTable({
          paging: this.paginacion,
          pageLength: this.max,
          searching: this.buscar,
          lengthChange: false,
          ordering: true,
          info: true,
          autoWidth: false,
          responsive: true,
          checkd: false,
          language: me.lang
        })
        .buttons()
        .container()
        .appendTo("#" + me.nombreTabla + "_wrapper .col-md-6:eq(0)");

    },
    async downloadBL(index) {
      let params = {
        bl_path: this.data[index].data_complementaria.path
      };

      let filePath = this.data[index].data_complementaria.path,
        fileNameWithExtension = filePath.split("/").pop(),
        fileName = fileNameWithExtension.split(".")[0];

      await downloadBillLadingPDF(params, fileName);
    },
    async showAlertBL() {
      return this.$vToastify.warning("Si desea descargar este archivo, debe acceder a el desde el historial de Nexus", "¡Aviso importante!")
    }
  },

  mounted() {
    let me = this;
    me.configuracionDatatable();
  },

  watch: {
    data: function(_new) {
      let me = this;

      if (_new) {

        $("#" + this.nombreTabla)
          .DataTable()
          .destroy();

        setTimeout(() => {
          me.data = _new;
        }, 300);

        setTimeout(() => {
          me.configuracionDatatable();
          me.ActionSetLoading(false);
        }, 700);
      }
    },

    acciones: function(_new) {
      if (_new) {
        this.acciones = _new;
      }
    }
  }
};
</script>

<style>
.hide-button-excel {
    display: none;
}

.buttons-colvis {
    background-color: #dc3545;
    color: #ffff;
    padding: 6px;
    border: none;
    border-radius: 3px;
    font-size: 15px;
}

.buttons-colvis:hover {
    background-color: #bd2130;
    border: none;
}

div.dataTables_wrapper div.dataTables_info {
    font-size: 13px !important;
}

.icono {
    opacity: 0.7;
}

.icono:hover {
    opacity: 1;
}

.btn-group-sm > .btn,
.btn-sm {
    padding: 0.25rem 0.45rem !important;
}

/* Table compact */

table.dataTable.compact thead th,
table.dataTable.compact thead td {
    padding: 3px 5px;
}

table.dataTable.compact tfoot th,
table.dataTable.compact tfoot td {
    padding: 3px;
}

table.dataTable.compact tbody th,
table.dataTable.compact tbody td {
    padding: 3px;
}

/* Table Hover */

table.dataTable.hover > tbody > tr:hover > * {
    box-shadow: inset 0 0 0 9999px rgba(0, 0, 0, 0.087) !important;
}

/* Stripe (Pintado de tabla estilo cebra) */

table.dataTable.stripe > tbody > tr.odd > *,
table.dataTable.display > tbody > tr.odd > * {
    box-shadow: inset 0 0 0 9999px rgba(0, 0, 0, 0.048);
}

/*  */

table.dataTable thead > tr > th.sorting,
table.dataTable thead > tr > th.sorting_asc,
table.dataTable thead > tr > th.sorting_desc,
table.dataTable thead > tr > th.sorting_asc_disabled,
table.dataTable thead > tr > th.sorting_desc_disabled,
table.dataTable thead > tr > td.sorting,
table.dataTable thead > tr > td.sorting_asc,
table.dataTable thead > tr > td.sorting_desc,
table.dataTable thead > tr > td.sorting_asc_disabled,
table.dataTable thead > tr > td.sorting_desc_disabled {
    cursor: pointer;
    position: relative;
    padding: 10px 0 !important;
    text-align: center;
}

.estilo_select {
    width: 100% !important;
    border-radius: 0.25em;
    padding: 5px 1px;
    font-size: 14px;
}
</style>
